import React, { useState } from 'react';
import AccessRequestSent from './AccessRequestSent';
import BluredArea from './BluredArea';
import RequestAccessCard from './RequestAccessCard';

const BlockedArea: React.FC<{ iSmallProfile: boolean }> = ({ iSmallProfile }) => {
  const [fullProfileAccessRequested, setFullProfileAccessRequested] = useState(false);

  return (
    <>
      {fullProfileAccessRequested ? (
        <AccessRequestSent iSmallProfile={iSmallProfile} />
      ) : (
        <>
          <RequestAccessCard setFullProfileAccessRequested={setFullProfileAccessRequested} />
          <BluredArea />
        </>
      )}
    </>
  );
};

export default BlockedArea;
